import {
  Box,
  Heading,
  Container,
  Grid,
  Stack,
  FormControl,
  HStack,
  Text,
  CircularProgress,
  useDisclosure,
  VStack,
  IconButton,
  useToast,
  Badge,
  Breadcrumb,
  BreadcrumbItem,
} from "@chakra-ui/react";
import Button from "components/Button/Button";

//Components
import Header from "components/dashHeader";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import NumberInput from "components/Input/NumberInput";
import Select from "components/Select/Select";
import Sidemenu from "components/sidemenu";
import { useCallback, useMemo, useState } from "react";

import { useParams, useHistory } from "react-router-dom";
import {
  useBuySellListingMutation,
  useGetSellListingByIdQuery,
} from "services/p2pApi";

import formatter from "util/formatter";
import { deduction, floatString, clamp } from "util/utils";
import { toLower } from "lodash";

// import AddPaymentDetails from "components/Modals/p2p/AddPaymentDetails";
import SuccessModal from "components/Modals/Success";
import { ChevronRightIcon, UpDownIcon } from "@chakra-ui/icons";
import { useEffect } from "react";
import { useGetCoinToUsdRateQuery } from "services/rateApi";

import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";

import constant from "config/constant";

// const getMaximumFilling = (data, formatRange = false) =>
//   formatRange
//     ? formatter(data.currency).format(
//         clamp(
//           data?.unfrozenBalance,
//           0,
//           data?.tradeOption?.maximumFilling ??
//             +data?.currentVolume?.$numberDecimal
//         ) * unitCost
//       )
//     : `${clamp(
//         data?.unfrozenBalance,
//         0,
//         data?.tradeOption?.maximumFilling ??
//           +data?.currentVolume?.$numberDecimal
//       )} ${toUpper(data.coin)}`;

const P2pBuySellLising = (props) => {
  const toast = useToast();
  const history = useHistory();
  const { id } = useParams();

  const { isOpen, onClose, onOpen } = useDisclosure();

  const reMapCoin = (coin) => {
    const map = {
      tbtc: "btc",
      teth: "eth",
      usdt: "usd",
    };
    return map[coin] ?? coin;
  };

  const { data, isLoading } = useGetSellListingByIdQuery(id);
  const { data: rate } = useGetCoinToUsdRateQuery(
    reMapCoin(data?.coin) ?? "btc"
  );

  const unitCost = useMemo(() => {
    if (data?.dynamic)
      return (
        (data?.coin?.includes("usd") ? 1 : rate?.exchangeRate?.buy) *
        data?.price
      );
    return data?.tradeOption?.unitCost;
  }, [data, rate]);

  console.log("SELL DATA", data, rate, "\n", unitCost);

  const [state, setState] = useState({});
  const [formatRange, setFormatRange] = useState(false);

  const handleSuccessModalClose = () => {
    onClose();
    history.replace("/dashboard/wallet");
  };

  const [
    makeBuy,
    {
      isLoading: isBuying,
      isError: isBuyError,
      isSuccess,
      data: buyData,
      error: buyError,
    },
  ] = useBuySellListingMutation();

  const buySellListing = useCallback(
    () =>
      makeBuy({
        id,
        volume: parseFloat(state.coinAmount),
        useInternalWallet: state.method === "bitmamaWallet",
      }),
    [makeBuy, id, state.coinAmount, state.method]
  );

  useEffect(() => {
    // console.log("BUY DATA", buyData);
    if (
      isSuccess &&
      state.method === "bitmamaWallet" &&
      buyData &&
      buyData?.paymentStatus === "paid"
    ) {
      // toast({
      //   position: "bottom-right",
      //   title: "Success",
      //   description: "Trade sold successfully",
      //   status: "success",
      //   duration: 9000,
      //   isClosable: true,
      // });

      onOpen();
    }

    if (
      isSuccess &&
      state.method !== "bitmamaWallet" &&
      buyData &&
      buyData?.tradeStatus === "inSession"
    ) {
      // console.log("TRADE SESSION", buyData);
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Trade session established successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      history.replace(
        `/dashboard/p2p/trades/session/${buyData?._id}-${buyData?.tradeRef}`
      );
    }
  }, [isSuccess, state.method, buyData, history, toast, onOpen]);

  useEffect(() => {
    // console.log("error!!", buyError);
    if (isBuyError && buyError)
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: buyError?.data?.error,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
  }, [buyError, isBuyError, toast]);

  // console.log("BUY DATA", buyData);

  const handleState = (data) => {
    setState({ ...state, ...data });
  };

  const handleVolume = (e) => {
    const coinAmount = floatString(Number(parseFloat(e) / unitCost).toFixed(2));
    handleState({ coinAmount, volume: e });
  };

  const handleCoinAmount = (e) => {
    const volume = floatString(Number(parseFloat(e) * unitCost).toFixed(2));
    handleState({ volume, coinAmount: e });
  };

  // console.log("DATA", data);

  const getMinimumFilling = (data, formatRange = false) =>
    formatRange
      ? formatter(data.currency).format(
          data?.tradeOption?.minimumFilling * unitCost
        )
      : toPrecision(data?.tradeOption?.minimumFilling ?? 0, data?.coin);

  const getMaximumFilling = (data, formatRange = false) =>
    formatRange
      ? formatter(data.currency).format(
          (data?.tradeOption?.maximumFilling ??
            +data?.currentVolume?.$numberDecimal) * unitCost
        )
      : toPrecision(
          +data?.tradeOption?.maximumFilling ??
            +data?.currentVolume?.$numberDecimal,
          data?.coin
        );
  // `${
  //     data?.tradeOption?.maximumFilling ??
  //     +data?.currentVolume?.$numberDecimal
  //   } ${toUpper(data.coin)}`;

  // const isCoinAmountLessThanUnfrozenBalance = () =>
  //   state?.coinAmount < +data?.unfrozenBalance;

  const isMinimumGreaterThanUnfrozenBalance = () =>
    (data?.tradeOption?.minimumFilling ?? 0) >
    clamp(data?.unfrozenBalance, 0, data?.tradeOption?.maximumFilling);

  const isCoinAmountInvalid = () =>
    (state?.coinAmount &&
      state.coinAmount < +data?.tradeOption?.minimumFilling) ||
    (state?.coinAmount &&
      state.coinAmount >
        (+data?.tradeOption?.maximumFilling ||
          +data?.currentVolume?.$numberDecimal));
  // state?.coinAmount > ;

  // console.log(
  //   "COIN AMOUNT IS INVALID",
  //   state?.coinAmount >
  //     (+data?.tradeOption?.maximumFilling ||
  //       +data?.currentVolume?.$numberDecimal),
  //   +data?.currentVolume?.$numberDecimal
  // );

  const isVolumeInvalid = () =>
    +state?.volume < Number(data?.tradeOption?.minimumFilling * unitCost) ||
    +state?.volume >
      Number(
        (data?.tradeOption?.maximumFilling ??
          data?.currentVolume?.$numberDecimal) * unitCost
      );

  const getFee = useCallback(
    () =>
      floatString(
        isNaN(deduction(state.coinAmount))
          ? "0.00"
          : deduction(state.coinAmount)
      ) ?? "0.00",
    [state?.coinAmount]
  );

  const getPaymentOptions = () => {
    let options = [];
    data?.paymentOption?.forEach((option) => {
      if (
        toLower(option.label) === "bitmama wallet" &&
        option.source === "internal"
      )
        options.push({ key: "bitmamaWallet", label: option.label });
      if (
        toLower(option.label) === "external wallet" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) === "changera"
      ) {
        options.push({ key: "changeraId", label: option.receivingIntoLabel });
      }
      if (
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "changera" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "bitmama wallet"
      )
        options.push({ key: "bankTransfer", label: "Bank Transfer" });
    });

    return options;
  };

  // console.log("PAYMENT OPTIONS", getPaymentOptions());

  const isCoinAmountLessThanMinimumAmount = useMemo(
    () =>
      state?.coinAmount &&
      parseFloat(state?.coinAmount) - parseFloat(getFee()) <
        (data?.tradeOption?.minimumFilling ?? 0),
    // eslint-disable-next-line
    [state?.coinAmount, data, getFee]
  );

  const isDisabled = () =>
    isCoinAmountInvalid() ||
    !(state.method && state.volume && state.coinAmount) ||
    isBuying ||
    isCoinAmountLessThanMinimumAmount;

  return (
    <>
      <Box
        __css={{
          "--color": "#4E4B66",
          "--borderColor": "#D9DBE9",
          "--focusColor": "#06c34491",
          "--primary": "#03A438",
        }}
      >
        <Sidemenu currentPage="P2P" logoutUser={props.logout} />
        <Header />

        <Box className="p2p">
          <Box
            className="p2p-container"
            p={["6em 0 !important", "6.5em 1.5em !important"]}
          >
            {isLoading && (
              <CircularProgress isIndeterminate size="20px" color="green" />
            )}
            {!isLoading && (
              <Container
                maxW={["100%", "container.xl"]}
                p={["0", "1.5rem", "1rem"]}
              >
                <Box px={["32px", "0", "0"]}>
                  <Heading fontSize="3xl">
                    Buy {toCoinLocale(data?.coin ?? "")}
                  </Heading>

                  <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                    <BreadcrumbItem>
                      <BreadcrumbLink to="/dashboard/p2p">P2P</BreadcrumbLink>
                    </BreadcrumbItem>

                    <BreadcrumbItem isCurrentPage>
                      <BreadcrumbLink isCurrentPage href="#">
                        Buy
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </Box>

                {/* {isMinimumGreaterThanUnfrozenBalance() && (
                  <Alert status="error" borderRadius="8px" maxW={["500px"]}>
                    <AlertIcon />
                    <AlertTitle mr={2}>Your browser is outdated!</AlertTitle>
                    <CloseButton position="absolute" right="8px" top="8px" />
                  </Alert>
                )} */}

                <Grid
                  templateColumns=".4fr .6fr"
                  overflow="hidden"
                  borderRadius={[0, 0, "16px"]}
                  mt={["32px", "32px", "48px"]}
                  d={["flex", "flex", "grid"]}
                  flexDir={["column", "column", "initial"]}
                >
                  {data?.adsStatus === "open" && (
                    <Box bg="white" p="32px">
                      <HStack>
                        <Heading fontSize="xl">Ad Details</Heading>

                        {isMinimumGreaterThanUnfrozenBalance() && (
                          <Badge colorScheme="red">Trade is busy</Badge>
                        )}
                      </HStack>
                      <Stack mt="24px">
                        <FormControl>
                          <Box
                            mb="8px"
                            as="label"
                            d="inline-block"
                            fontSize="md"
                            color="#4E4B66"
                          >
                            I want to buy
                          </Box>

                          <NumberInput
                            disabled={isMinimumGreaterThanUnfrozenBalance()}
                            isInvalid={
                              isCoinAmountLessThanMinimumAmount ||
                              isCoinAmountInvalid()
                            }
                            value={
                              isNaN(state?.coinAmount) ? "" : state.coinAmount
                            }
                            placeholder="0.00"
                            endAdornment={toCoinLocale(data?.coin ?? "")}
                            onChange={handleCoinAmount}
                          />

                          {/* {isCoinAmountLessThanUnfrozenBalance() && (
                          <Text
                            fontSize="xs"
                            mt="6px"
                            color="var(--errorTextColor)"
                          >
                            Coin amount{" "}
                          </Text>
                        )} */}

                          {isCoinAmountInvalid() && (
                            <Text
                              fontSize="xs"
                              mt="6px"
                              color="var(--errorTextColor)"
                            >
                              Coin amount must not exceed the{" "}
                              {data.tradeOption.minimumFilling}{" "}
                              {toCoinLocale(data.coin)} min and{" "}
                              {data.tradeOption.maximumFilling ??
                                data?.currentVolume?.$numberDecimal}{" "}
                              {toCoinLocale(data.coin)} max range.
                            </Text>
                          )}

                          {isCoinAmountLessThanMinimumAmount &&
                            !isCoinAmountInvalid() && (
                              <Text
                                fontSize="xs"
                                mt="6px"
                                color="var(--errorTextColor)"
                              >
                                {toPrecision(
                                  state?.coinAmount ?? 0,
                                  data?.coin
                                )}{" "}
                                - {toPrecision(+getFee() ?? 0, data?.coin)}{" "}
                                (fee) should be more than the minimum range.
                              </Text>
                            )}
                        </FormControl>
                        <FormControl mt="14px !important">
                          <Box
                            mb="8px"
                            as="label"
                            d="inline-block"
                            fontSize="md"
                            color="#4E4B66"
                          >
                            Amount I would pay
                          </Box>

                          <NumberInput
                            disabled={isMinimumGreaterThanUnfrozenBalance()}
                            isInvalid={isVolumeInvalid()}
                            value={isNaN(state?.volume) ? "" : state?.volume}
                            placeholder="0.00"
                            endAdornment={String(
                              data?.currency ?? ""
                            ).toUpperCase()}
                            onChange={handleVolume}
                          />

                          {/* {isVolumeInvalid() && (
                          <Text
                            fontSize="xs"
                            mt="6px"
                            color="var(--errorTextColor)"
                          >
                            Volume must not exceed{" "}
                            {getMinimumFilling(data, true)} min and{" "}
                            {getMaximumFilling(data, true)} max range.
                          </Text>
                        )} */}
                        </FormControl>
                        <FormControl mt="14px !important">
                          <Box
                            mb="8px"
                            as="label"
                            d="inline-block"
                            fontSize="md"
                            color="#4E4B66"
                          >
                            Pay with
                          </Box>
                          <Select
                            disabled={isMinimumGreaterThanUnfrozenBalance()}
                            value={state?.method ?? ""}
                            onChange={(e) =>
                              handleState({ method: e.target.value })
                            }
                            placeholder="Choose Method"
                          >
                            {/* <option value="changeraId">Changera</option> */}
                            {/* <option value="bitmamaWallet">Bitmama Wallet</option>
                          <option value="bankTransfer">Bank Transfer</option> */}
                            {getPaymentOptions().map((option) => (
                              <option key={option.key} value={option.key}>
                                {option.label}
                              </option>
                            ))}
                          </Select>
                        </FormControl>
                      </Stack>
                      <HStack justifyContent="space-between" mt="14px">
                        <Text>Fees</Text>
                        <HStack>
                          <Text>{toPrecision(+getFee() ?? 0, data?.coin)}</Text>
                          {/* <Text color="#A0A3BD">{toUpper(data?.coin)}</Text> */}
                        </HStack>
                      </HStack>

                      <HStack
                        mt="40px !important"
                        pb="40px"
                        justifyContent="center"
                        gridGap="20px"
                      >
                        <Button
                          // h="56px"
                          disabled={
                            isBuying || isMinimumGreaterThanUnfrozenBalance()
                          }
                          minW="120px !important"
                          // px="10px"
                          bg="transparent"
                          border="2px solid #03A438"
                          color="#03A438"
                          onClick={() => history.push(constant.PAGES.P2P.HOME)}
                        >
                          Cancel
                        </Button>
                        <Button
                          isLoading={isBuying}
                          disabled={
                            isDisabled() ||
                            isMinimumGreaterThanUnfrozenBalance()
                          }
                          onClick={() =>
                            // history.push("/dashboard/p2pv2/makepayment")
                            // onOpen()
                            buySellListing()
                          }
                          minW="120px !important"
                        >
                          Buy
                        </Button>
                      </HStack>
                    </Box>
                  )}

                  <Box
                    bg={["#fff", "#fff", "#F1F1F1"]}
                    p={["32px", "32px", "32px 80px"]}
                    pt={["0", "0", "32px"]}
                  >
                    {data?.adsStatus !== "open" && (
                      <Badge colorScheme="red">{data?.adsStatus}</Badge>
                    )}
                    <Heading
                      fontSize="xl"
                      borderTop={[
                        "1px solid #D9DBE9",
                        "1px solid #D9DBE9",
                        "none",
                      ]}
                      pt={["32px", "32px", "0"]}
                    >
                      Listing Details
                    </Heading>

                    {/* <HStack justifyContent="space-between" mt="24px">
                      <Stack>
                        <Text color="#4E4B66">Seller</Text>
                        <Text fontSize="sm" mt="2px !important" color="#3151AB">
                          {String(data?.userData?.firstName ?? "")}{" "}
                          {String(data?.userData?.lastName ?? "")}
                        </Text>
                      </Stack>
                      <Stack>
                        <Text color="#4E4B66">Price</Text>
                        <HStack mt="2px !important">
                          <Text fontWeight="bold">
                            {Number(
                              data?.totalCost?.$numberDecimal ?? 0
                            ).toLocaleString()}
                          </Text>
                          <Text fontSize="xs" alignSelf="flex-end">
                            {String(data?.currency ?? "").toUpperCase()}
                          </Text>
                        </HStack>
                      </Stack>
                    </HStack> */}
                    <HStack justifyContent="space-between" mt="24px">
                      <VStack alignItems="flex-start">
                        <Stack>
                          <Text color="#4E4B66">Seller</Text>
                          <Text
                            fontSize="sm"
                            mt="2px !important"
                            color="#3151AB"
                          >
                            {/* {String(data?.userData?.firstName ?? "")}{" "}
                            {String(data?.userData?.lastName ?? "")} */}
                            {String(data?.userData?.username ?? "")}
                          </Text>
                        </Stack>

                        <Stack mt="24px !important">
                          <Text color="#4E4B66">Available</Text>
                          <Text fontSize="sm" mt="2px !important">
                            {/* {data?.unfrozenBalance ?? 0}{" "}
                            {to(data?.coin ?? "").toUpperCase()} */}
                            {toPrecision(
                              data?.unfrozenBalance ?? 0,
                              data?.coin
                            )}
                          </Text>
                        </Stack>
                        <Stack mt="24px !important">
                          <HStack>
                            <Text color="#4E4B66">Buy range</Text>
                            <IconButton
                              _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                              aria-label="Convert range"
                              minW="22px"
                              h="14px"
                              colorScheme="green"
                              onClick={() => setFormatRange(!formatRange)}
                              icon={
                                <Box
                                  transform="rotate(-90deg)"
                                  as={UpDownIcon}
                                  fontSize="10px"
                                />
                              }
                            />
                          </HStack>
                          <Text fontSize="sm" mt="2px !important">
                            {`${getMinimumFilling(
                              data,
                              formatRange
                            )} - ${getMaximumFilling(data, formatRange)}`}
                          </Text>
                        </Stack>
                      </VStack>

                      <VStack alignItems="flex-start">
                        <Stack>
                          <Text color="#4E4B66">Price</Text>
                          <HStack mt="2px !important">
                            <Text fontWeight="bold">
                              {Number(unitCost ?? 0).toLocaleString()}
                            </Text>
                            <Text fontSize="xs" alignSelf="flex-end">
                              {String(data?.currency ?? "").toUpperCase()}
                            </Text>
                          </HStack>
                        </Stack>

                        <Stack mt="24px !important">
                          <Text color="#4E4B66">Time limit</Text>
                          <HStack mt="2px !important">
                            <Text fontSize="sm">
                              {data?.timeout ?? "0"} min
                            </Text>
                          </HStack>
                        </Stack>

                        <Stack mt="24px !important">
                          <Text color="#4E4B66">Location</Text>
                          <HStack mt="2px !important">
                            <Text fontSize="sm">{data?.location}</Text>
                          </HStack>
                        </Stack>
                      </VStack>
                    </HStack>

                    {/* <HStack justifyContent="space-between" mt="24px">
                      <Stack>
                        <Text color="#4E4B66">Available</Text>
                        <Text fontSize="sm" mt="2px !important">
                          {data?.volume?.$numberDecimal ?? 0}{" "}
                          {String(data?.coin ?? "").toUpperCase()}
                        </Text>
                      </Stack>
                      <Stack>
                        <Text color="#4E4B66">Time limit</Text>
                        <HStack mt="2px !important">
                          <Text fontSize="sm">{data?.timeout ?? "0"} min</Text>
                        </HStack>
                      </Stack>
                    </HStack> */}
                    {/* {data?.currency && (
                      <HStack justifyContent="space-between" mt="24px">
                        <Stack>
                          <Text color="#4E4B66">Buy range</Text>
                          <Text fontSize="sm" mt="2px !important">
                            {`${getMinimumFilling(data)} - ${getMaximumFilling(
                              data
                            )}`}
                          </Text>
                        </Stack>
                        <Stack>
                          <Text color="#4E4B66">Location</Text>
                          <HStack mt="2px !important">
                            <Text fontSize="sm">Lagos</Text>
                          </HStack>
                        </Stack>
                      </HStack>
                    )} */}
                    {data?.terms && (
                      <HStack
                        justifyContent="space-between"
                        mt="32px !important"
                        p="32px 0"
                        borderTop="1px solid #D9DBE9"
                      >
                        <Stack>
                          <Text color="#4E4B66">Terms</Text>
                          <Text fontSize="sm" mt="2px !important">
                            {data?.terms}
                          </Text>
                        </Stack>
                      </HStack>
                    )}
                  </Box>
                </Grid>
              </Container>
            )}
          </Box>

          {/* <AddPaymentDetails
            state={state}
            setState={setState}
            isOpen={isOpen}
            onClose={onClose}
          /> */}

          <SuccessModal
            isOpen={isOpen}
            onClose={handleSuccessModalClose}
            title="Success"
            message="Your trade was successful"
          />
        </Box>
      </Box>
    </>
  );
};

export default P2pBuySellLising;
